
import { LoginCentered, LoginWithBackground } from 'navigation/login';
import { UserOnboardingCentered, UserOnboardingWithBackground } from 'navigation/userOnboarding';
import {
  PasswordResetCentered,
  PasswordResetWithBackground,
  ChangePasswordCentered,
  ChangePasswordWithBackground,
} from 'navigation/passwordReset';

import { hostIsBgoResidents } from 'helpers/CurrentWindowLocation';

export const loginPage = hostIsBgoResidents() ? LoginWithBackground : LoginCentered;

export const userOnboardingPage = hostIsBgoResidents()
  ? UserOnboardingWithBackground
  : UserOnboardingCentered;

export const passwordResetPage = hostIsBgoResidents()
  ? PasswordResetWithBackground
  : PasswordResetCentered;

export const updatePasswordPage = hostIsBgoResidents()
  ? ChangePasswordWithBackground
  : ChangePasswordCentered;